module.exports = __webpack_public_path__ + "static/media/design-your-vr-exhibition-after.dc976eb4.png";